import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function DepositWith6xWin28xBonusPromoFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const brandName = (brandId === 33 || brandId === 34) ? 'IW247' : (brandId === 39 || brandId === 40) ? 'Fomo7' : (brandId === 46 || brandId === 47) ? 'Fun88' : 'Yolo247';
    const totalPromotion = brandId === 61 ? '$650,000' : '₹6,50,00,000';

    return (
        <>
            <InformationWrapper>
                <TitleConatiner>
                    <h1>Deposit With 6 - Hit Milestones, Win Big</h1>
                    <p>When your deposit count reaches <strong>6, 16, or 26</strong>, you become eligible for a <strong>chance-based</strong> <br /> <strong>bonus up to 26x your deposit</strong></p>
                    <Link to='/member/finance/deposit'>Deposit Now</Link>
                </TitleConatiner>
                <Container>
                    <LeftCardWrapper>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DepositWith6xWin26xBonusIconOne}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Keep depositing on {brandName}</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DepositWith6xWin26xBonusIconTwo}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Reach your <strong>6th, 16th, or 26th deposit</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.DepositWith6xWin26xBonusIconThree}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Receive a chance - based bonus</strong></p>
                        </LeftCard>
                    </LeftCardWrapper>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.DepositWith6xWin26xBonusImageOne}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Container>

                <Container>
                    <TermsImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.DepositWith6xWin26xBonusTermsImage}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </TermsImageWrapper>
                    <RightCradWrapper>
                        <RightCard><p>Valid from <strong>01 Jan 2026 to 28 Feb 2026</strong></p></RightCard>
                        <RightCard><p><strong>Bonus payout is chance-based and not guaranteed</strong></p></RightCard>
                        <RightCard><p>Bonus credited as a <strong>non-withdrawable bonus</strong></p></RightCard>
                        <RightCard><p><strong>Winnings from the bonus are credited to the wallet</strong></p></RightCard>
                        <RightCard><p><strong>Maximum bonus subject to internal cap</strong></p></RightCard>
                        <RightCard><p>Estimated total promotion pool: <strong>{totalPromotion}</strong></p></RightCard>
                        <RightCard><p><strong>{brandName}'s decision is final and binding</strong></p></RightCard>
                        <RightCard><p><strong>General {brandName} terms & conditions apply</strong></p></RightCard>
                    </RightCradWrapper>
                </Container>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(DepositWith6xWin28xBonusPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;
    text-transform: capitalize;
`;

const TitleConatiner = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;

    h1 {
        color: #F063EF;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin: 0;
    }

    p {
        color: #444;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }

    a {
        background: linear-gradient(94deg, #77A5D6 3.16%, #8AEAF9 100%), linear-gradient(180deg, #7ABDD8 0%, #006993 101.45%);
        padding: 0.75rem 3rem;
        border: 2px solid #77A5D6;
        border-radius: 15px;
        box-shadow: 0 0 10px rgba(138, 234, 249, 0.50);
        color: #FFF;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 27px;
        text-transform: uppercase;
        cursor: pointer;
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 2rem 1.5rem;
    border-radius: 8px;
`;

const LeftCardWrapper = styled.div`
    flex: 0 0 45%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;
    gap: 1rem;
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    flex: 1;
    
    img {
        width: 70%;
        align-self: flex-start;
    }
`;

const LeftCard = styled.div`
    width: 70%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    border-radius: 9.556px;
    border: 1px solid #B6B6B6;
    border-radius: 10px;
    background: linear-gradient(0deg, #EBEBEB 0%, #EBEBEB 100%), rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(7.5px);
    padding: 1.5rem 2.5rem 1.5rem 2.5rem;

    img {
        width: 55px;
    }

    p {
        width: 85%;
        color: #444;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 700;
        line-height: 21px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const TermsImageWrapper = styled.div`
    flex: 0 0 45%;
    display: flex;
    text-align: right;
    justify-content: center;
    align-items: flex-start;

    img {
        width: 70%;
        align-self: flex-end;
    }
`;

const RightCradWrapper = styled.ul`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
`;

const RightCard = styled.li`
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    background: #EBEBEB;
    backdrop-filter: blur(7.5px);
    padding: 10px 25px;

    p {
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
    }
`;
